export default "__VITE_ASSET__DmbKWSQb__"